import { HTTP } from "../../../services/api-service.js";
import commonObj from "../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "Item";

const itemMasterStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "",
      take: 1000000,
      skip: 1
      // take: 15
    },
    pagesCount: 0,
    currentSelectedPage: 0
  },
  actions: {
    getAllItemMaster({ commit, state }, param = {}) {
      let skip = state.q.skip;
      let take = state.q.take;
      let searchCriteria = state.q.searchCriteria;

      if ("skip" in param) {
        skip = param.skip;
      }

      if ("take" in param) {
        take = param.take;
      }

      if ("searchCriteria" in param) {
        searchCriteria = param.searchCriteria;
      }

      console.log(param, skip, "----getAllItemMaster");

      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", {
          ...state.q,
          take,
          skip,
          searchCriteria
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getProductDetail({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/GetItemProfile", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveItemMaster({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/item/SaveItemv20230425",
          JSON.stringify({
            item: param.item,
            ingredients: param.ingredient,
            itemPxs: param.itemPxs,
            itemBarcodes: param.itemBarcodes,
            itemTerms: param.itemTerms,
            itemEntRefs: param.itemEntRefs
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fileUpload({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/fileUpload", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fileDownload({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/fileDownload", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getItemLabel({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/files", {
          itemNum: param
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getPODtlListByItemNum({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/GetPODtlListByItemNum", {
          itemnum: param.itemNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getItemPx({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/GetItemPx", { itemNum: param.itemNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getStockBal({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/GetItemStock", { itemNum: param.itemNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getOtherRef({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/GetItemEntRef", { itemNum: param.itemNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getItemEntRefByEntity({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/ItemEntRefByEntity", {
          ItemNum: param.itemNum,
          EntNum: param.entNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getIngredient({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/GetItemIngredient", {
          itemNum: param.itemNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getBarcode({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/GetItemBarcode", { itemNum: param.itemNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getItemsByDesc({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/getitemsbydesc", {
          itemDesc: param.itemDesc
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getImages({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/images", { itemNum: param.itemNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getTxLedgerList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stock/StockLedger", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveItemImage({ commit }, param) {
      const APIMultiFormDataSetting = {
        baseURL: baseUrl,
        timeout: 50000,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      return new Promise((resolve, reject) => {
        HTTP.post("/item/SaveItemImage", param, APIMultiFormDataSetting)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteItemImage({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/deleteimage", { imgFolder: param })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    delItemLabel({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/filedelete", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteItemMaster({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/DeleteItem", { itemNum: param.itemNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    getItemUDFList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/GetUDFList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    saveItemPriceClass({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/item/ImportItemPx",
          JSON.stringify({
            itemPx: param.model
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default itemMasterStore;
